import React from 'react';
import Box from '@mui/material/Box';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Accordions from '../components/Accordions/Accordions';
import SmallCards from '../components/Cards/SmallCards';
import TextBtnSection from '../components/Section/TextBtnSection';
import ContentCard from '../components/Cards/ContentCard';
import BigCard from '../components/Cards/BigCard';
import { useTranslation } from '../hook/Translation';

export default function ExionRFBodySkinTightening() {
    const { t } = useTranslation();
   const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description:  t('exion_rf_body_skin_tightening.time'),
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description:  t('exion_rf_body_skin_tightening.discomfort'),
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description:  t('exion_rf_body_skin_tightening.downtime'),
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description:  t('exion_rf_body_skin_tightening.sessions'),
        }
    ];

    const accodirons = [
        {
            title: t('what'),
            content: t('exion_rf_body_skin_tightening.what')
        },
        {
            title: t('how'),
            content: t('exion_rf_body_skin_tightening.how')
        },
        {
            title: t('benefits'),
            content: t('exion_rf_body_skin_tightening.benefits')
        },
        {
            title: t('zone'),
            content: t('exion_rf_body_skin_tightening.zone')
        },
        {
            title: t('pairs'),
            content: t('exion_rf_body_skin_tightening.pairs')
        },
        {
            title: t('when_expected_results'),
            content: t('exion_rf_body_skin_tightening.expected_results')
        },
        {
            title: t('results'),
            content: t('exion_rf_body_skin_tightening.results')
        },
    ]

    return (
        <Box>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'#1E353D'}>
                        <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2026/05/img_69f88a571b8205.30065116.jpg`} height={1} width={1} className='fitCover' />
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className="generalContainer" marginX={'auto'} marginTop={{ md: '80px', xs: '50px' }}>
                <TextBtnSection
                    // titleSize={{ md: 8, xs: 12 }}
                    // descriptionSize={{}}
                    data={{
                        type: t('bodyherapies'),
                        title: t('exion_body.mainTitle'),
                        description: t('exion_rf_body_skin_tightening.mainDesc'),
                        bookUrl: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EXION BODY")}`,
                        // learn: ""
                        price: `${t('exion_rf_body_skin_tightening.session')}: €150\n${t('price_package')} 6 ${t('price_seanc')}: €750`,

                        doctorIncluded: true
                    }}
                />
            </Box>

            <Box marginTop={{ md: '151px', xs: '50px' }}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>

            <Box>
                <Box marginTop={{ md: '104px', xs: '50px' }} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data2} />
                </Box>
            </Box>

            {/* <Grid container className='generalContainer' marginX={'auto'} spacing={2} marginTop={{md: '141px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" className='dColor' fontWeight={'bold'} fontSize={{ md: '30px', xs: '1.125rem' }}>
                        A technician glides a smoothing handpiece over the area while controlled heat penetrates deep into the dermis. The sensation is warm and comfortable, similar to a hot stone massage, with settings adjusted to stay in the optimal therapeutic range for collagen remodeling.                    
                    </Typography>
                </Grid>
            </Grid> */}
            <Box sx={{ width: { md: '65%', xs: '90%' }, marginX: 'auto' }} marginTop={{md: '140px', xs: '50px'}}>
                <Box sx={{ height: { md: 440, xs: 'auto' } }}>
                    <BigCard
                        data={{
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EXION BODY")}`,
                            type: t('exion_rf_body_skin_tightening.tech'),
                            // learn: '/',
                            title: t('exion_body.techTitle'),
                            size: { md: 7, xs: 12 },
                            btnContainer: { md: 10, xs: 12 },
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/ALMA4.png`,
                            imageSize: {md: 5, xs: 12},
                            flexDirection: {md: 'row-reverse', xs: 'column-reverse'},
                            description: t('exion_rf_body_skin_tightening.techDesc')
                        }}
                        bgColor={'rgba(30, 53, 61, 1)'}
                    />
                </Box>
            </Box>

            <Grid container gap={{ md: '80px', xs: '30px' }} className='generalContainer' marginTop={{md: '111px', xs: '50px'}} sx={{ marginX: 'auto'}}marginBottom={{ md: '140px', xs: '50px' }} >
                 <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" className='dColor' fontSize={{ md: '1.125rem', xs: '1rem' }} fontWeight={'bold'}>{t('additional_information')}</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>

            {/* <Grid container marginTop={{ md: '140px', xs: '50px' }} className='generalContainer' sx={{ marginX: 'auto'}}>
                <Grid size={12}>
                    <Grid container>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <Typography textAlign={'center'} variant="body1" className='dColor' fontSize={{ md: '1.125rem', xs: '1rem' }} fontWeight={'600'}>Treatment Areas</Typography>
                            </Grid>
                            <Grid size={12}>
                                <Typography textAlign={'center'} variant="body1" className='dColor' fontWeight={'600'} fontSize={{ md: '30px', xs: '1.125rem' }}>
                                    Anywhere body skin is lax: popular zones include post-baby or post-weight-loss abdomen, upper arms , the knees , thighs and buttocks .We also use it on the neck or chest for clients who have crepe skin there.
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid size={12} bgcolor={'#DBDAD9'} height={'2px'} marginTop={{md: '33px', xs: ''}} marginBottom={{md: '47px', xs: ''}}>
                        </Grid>
                        <Grid size={12}>
                            <Grid container spacing={2}>
                                <Grid size={12}>
                                    <Typography textAlign={'center'} variant="body1" className='dColor' fontSize={{ md: '1.125rem', xs: '1rem' }} fontWeight={'600'}>Sessions</Typography>
                                </Grid>
                                <Grid size={12}>
                                    <Typography textAlign={'center'} variant="body1" className='dColor' fontWeight={'600'} fontSize={{ md: '30px', xs: '1.125rem' }}>
                                        A typical protocol is 4 6 sessions about 1-2 weeks apart. As collagen rebuilds, you’ll notice skin becoming gradually more taut and smooth. It’s perfect for someone not ready or not needing surgery, but who wants a bit of tightening and lift in specific areas
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Box bgcolor={'#DBDAD9'} marginTop={{md: '140px', xs: '50px'}} paddingTop={{md: '120px', xs: '50px'}} paddingBottom={{md: '183px', xs: '50px'}}>
                <Box className="generalContainer" marginX={'auto'} gap={'89px'} display={'flex'} flexDirection={'column'}>
                    <ContentCard
                        data={{
                            type: 'Pairing',
                            title: 'Emsculpt NEO',
                            description: 'The perfect follow up once muscle tone is built and fat is reduced. Emsculpt NEO strengthens and sculpts from within using HIFEM and radiofrequency, while Exion RF Skin Tightening refines the surface by stimulating collagen and improving elasticity. Together they create smoother, firmer, and more defined contours, giving both structure and finish.',
                            direction: { md: 'row-reverse', xs: 'row' },
                            learn: "/skin/fractional-co2-resurfacing",
                            book: '/'
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />

                    <ContentCard
                        data={{
                            type: 'Pairing',
                            title: 'Emtone',
                            description: 'It’s also great combined with Emtone for cellulite RF tightening plus Emtone’s acoustic wave can yield firmer and smoother thighs or buttocks. And don’t forget maintenance: an annual single-session “touch-up” after your initial series will help keep your results over time, as skin will continue to age naturally.',
                            learn: "/skin/hybrid-laser-erbium-glass",
                            book: '/'
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                </Box>
            </Box> */}
        </Box>
    )
}